import { gql } from '@apollo/client';

export class ProfileGQLFunction {
  static GET_SERVER_PROFILEPO = gql`
    query serverProfile {
      getServerProfile {
        cn
        o
        ouList
        domain
        domainProfile {
          apiServerGrpc {
            api
            host
            port
          }
          apiServerHttp {
            api
            host
            port
          }
          fileServerGrpc {
            api
            host
            port
          }
          fileServerHttp {
            api
            host
            port
          }
          backupServerGrpc {
            api
            host
            port
          }
          backupServerHttp {
            api
            host
            port
          }
          streamingServer {
            api
            host
            port
          }
        }
        themeIcon
        themeColor
        desktopUpdateLink
        msgRetention
        fileRetention
        inActiveUserRetention
      }
    }
  `;

  // static UPDATE_SERVER_PROFILEPO = gql`
  //   mutation updateServerProfile(
  //     $name: String!,
  //     $domain: String!,
  //     $appId: String!,
  //     $auth: String!,
  //     $expiresIn: String!,
  //     $grpcServerHost: String!,
  //     $grpcServerPort: Int!,
  //     $httpServerHost: String!,
  //     $httpServerPort: Int!,
  //     $fileServerHost: String!,
  //     $fileServerPort: Int!,
  //     $msgRetention: Int!,
  //     $fileRetention: Int!,
  //     $inActiveUserRetention: Int!) {
  //       updateServerProfile(
  //         name: $name,
  //         domain: $domain,
  //         appId: $appId,
  //         auth: $auth,
  //         expiresIn: $expiresIn,
  //         grpcServerHost: $grpcServerHost,
  //         grpcServerPort: $grpcServerPort,
  //         httpServerHost: $httpServerHost,
  //         httpServerPort: $httpServerPort,
  //         fileServerHost: $fileServerHost,
  //         fileServerPort: $fileServerPort,
  //         msgRetention: $msgRetention,
  //         fileRetention: $fileRetention,
  //         inActiveUserRetention: $inActiveUserRetention
  //       ) {
  //         serverProfile {
  //           name
  //           domain
  //           appId
  //           auth
  //           expiresIn
  //           grpcServerHost
  //           grpcServerPort
  //           httpServerHost
  //           httpServerPort
  //           fileServerHost
  //           fileServerPort
  //           msgRetention
  //           fileRetention
  //           inActiveUserRetention
  //         }
  //         err
  //         msg
  //       }
  //   }
  // `;
}
